var map = {
	"./oblis-school/advanced/fr.ts": [
		9569,
		9569
	],
	"./oblis-school/advanced/nl.ts": [
		90651,
		651
	],
	"./oblis-school/beginner/fr.ts": [
		20933,
		933
	],
	"./oblis-school/beginner/nl.ts": [
		7655,
		7655
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 33064;
module.exports = webpackAsyncContext;